import { render, staticRenderFns } from "./query.vue?vue&type=template&id=a920e3e0&scoped=true&"
import script from "./query.vue?vue&type=script&lang=ts&"
export * from "./query.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a920e3e0",
  null
  
)

export default component.exports